<template>
  <router-view></router-view>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
body{
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
 
}
.container{
  width: 100vw;
  min-height: 100vh;
  position: relative;
  /* overflow: hidden; */
  background-color: #f5f5f5;
  /* padding-bottom: 100px;
  box-sizing: border-box; */
  /* background-color: #2c3e50; */
}


/* 统一按钮样式 */
	.obtn{
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 700;
		color: #fff;
		background: #5aa279;
		border-radius: .125rem;
	}

  /* 字体颜色 */
  .txtcolor{
    color: #2dc378;
  }
	
	 /* 超出省略号 */
	.hiddenbox{
	  overflow: hidden; /* 隐藏超出部分 */
	  white-space: nowrap; /* 不换行 */
	  text-overflow: ellipsis; /* 超出部分显示省略号 */
	}

  .nullBox{
    width: 100%;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .nullBox .iconfont{
    font-size: 150px;
    margin-bottom: 30px;
    color: #969b9e;
  }
  .nulltxt{
    font-size: 35px;
    color: #969b9e;
  }


  /* 底部tab切换 */
  .bottomTabbox{
    width: 100vw;
    height: 120px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .bottomtabitem{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bottomtabitem img{
    width: 55px;
  }
  .bottomtabtxt{
    font-size: 26px;
    margin-top: 10px;
    color: #949893;
  }
  .selecttabtxt{
    color: #7fae8a;
  }

  /* 没有更多了 */
  .nomore{
    width: 100%;
    text-align: center;
    font-size: 23px;
    color: #a8a8a8;
    margin-top: 20px;
}
</style>
